import { Flex, Input, InputGroup, InputProps, InputRightElement, StackProps, Text, VStack } from '@chakra-ui/react';
import { useForm } from 'react-hook-form';
import { AddIcon } from './add-icon';
import { ProductIcon } from './product-icon';
import { RemoveIcon } from './remove-icon';

export type OnAddItemProps = {
  value: string;
  clearInput: () => void;
};

export type OnRemoveItemProps = {
  item: string;
};

interface InputElementProps extends InputProps {
  onAddItem: ({ value, clearInput }: OnAddItemProps) => void;
}

interface ListSectionProps extends StackProps {
  valuesArray: string[];
  onRemoveItem: ({ item }: OnRemoveItemProps) => void;
}

const defaultValues = {
  value: '',
};

const MultiValuesInputInput = (props: InputElementProps) => {
  const { onAddItem, ...rest } = props;
  const { register, setValue, watch } = useForm({
    mode: 'onBlur',
    reValidateMode: 'onChange',
    defaultValues: { ...defaultValues },
  });
  const value = watch('value');

  const clearInput = () => {
    setValue('value', defaultValues.value);
  };

  const handleAddItem = () => onAddItem({ value, clearInput });

  return (
    <InputGroup>
      <Input type='text' variant='outline' {...register('value')} {...rest} />
      <InputRightElement cursor={value ? 'pointer' : 'default'} onClick={handleAddItem}>
        <AddIcon fill={value ? 'red.500' : 'gray.200'} />
      </InputRightElement>
    </InputGroup>
  );
};

const MultiValuesInputList = (props: ListSectionProps) => {
  const { valuesArray, onRemoveItem, ...rest } = props;
  const handleRemoveItem = (item: string) => onRemoveItem({ item });

  return (
    <VStack spacing='.5rem' align='stretch' mt='1rem' {...rest}>
      {valuesArray?.map((item) => (
        <Flex key={item} justify='flex-start' align='center'>
          <ProductIcon me='1rem' />
          <Text textAlign='start' flex={1}>
            {item}
          </Text>
          <RemoveIcon cursor='pointer' onClick={() => handleRemoveItem(item)} />
        </Flex>
      ))}
    </VStack>
  );
};

/** Namespace for the two parts of a "type a value, press add, see the list" field; renders nothing itself. */
export const MultiValuesInput = (): null => null;

MultiValuesInput.Input = MultiValuesInputInput;
MultiValuesInput.List = MultiValuesInputList;
